import React from 'react';
import { Box, useTheme } from '@mui/material';

const WeekHeader = ({ group, dayWidth, isLast }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: `${group.days * dayWidth}px`,
        minWidth: `${group.days * dayWidth}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontWeight: 500,
        fontSize: '12px',
        borderRight: !isLast ? `2px solid ${theme.palette.grey[500]}` : 'none',
        bgcolor: group.week % 2 === 0 ? 'grey.700' : 'grey.600',
      }}
    >
      {group.week}
    </Box>
  );
};

export default WeekHeader;
